import React, { Component } from 'react';
import { connect } from 'react-redux';

import { deliveryOptionsActions } from '../../redux/actions/deliveryOptions';
import { utilsActions } from '../../redux/actions/utils';
import { createLoadingSelector } from '../../redux/selectors/loader';

import Loader from '../../layouts/admin/Loader';
import Header from './Header';
import DeliveryOptionPage from './DeliveryOptionPage';
import ActionConfirmModal from '../../layouts/admin/ActionConfirmModal';

import './DeliveryOption.scss';

const editDeliverySchema = {
    carrierCode: '',
    code: '',
    name: '',
    description: '',
    deliveryType: '',
    price: 0,
    cutOffTime: '',
    active: false,
    channel: '',
    store: '',
    channels: [],
};
class DeliveryOption extends Component {
    state = {
        editDelivery: editDeliverySchema,
        openDuplicateModal: false,
        openDeleteModal: false,
        changeMade: false,
        firstLoad: true,
    };

    componentDidMount() {
        const { getChannels, getStores } = this.props;
        getChannels();
        getStores();
        this.refreshDelivery();
    }

    componentDidUpdate() {
        const { deliveryOption } = this.props;
        const { editDelivery, changeMade, firstLoad } = this.state;
        editDelivery.channels.sort();
        if (firstLoad && JSON.stringify(deliveryOption) !== JSON.stringify(editDelivery)) {
            this.setFirstLoad(false);
            this.setEditDelivery(deliveryOption);
            if (changeMade !== true) this.setChangeMade(true);
        } else if (JSON.stringify(deliveryOption) !== JSON.stringify(editDelivery)) {
            if (changeMade !== true) this.setChangeMade(true);
        } else {
            if (changeMade !== false) this.setChangeMade(false);
        }
    }

    refreshDelivery() {
        const { getDeliveryOption, match } = this.props;

        getDeliveryOption(match.params.id);
    }

    setFirstLoad(firstLoad) {
        this.setState({ firstLoad });
    }

    setChangeMade(changeMade) {
        this.setState({ changeMade });
    }

    setEditDelivery(subject) {
        this.setState({ editDelivery: Object.assign({}, subject) });
    }

    setOpenDuplicateModal(openDuplicateModal) {
        this.setState({ openDuplicateModal });
    }

    setOpenDeleteModal(openDeleteModal) {
        this.setState({ openDeleteModal });
    }

    onFieldChange(name, value) {
        const { editDelivery } = this.state;
        let formattedValue;
        if (!Object.keys(editDeliverySchema).find(n => n === name)) return;

        switch (name) {
            case 'price':
                formattedValue = this.formatPrice(value);
                break;
            case 'carrierCode':
                return;
            // formattedValue = value.replace(/\s+/g, "").toUpperCase();
            // break;
            default:
                formattedValue = value;
                break;
        }
        editDelivery[name] = formattedValue;

        this.setEditDelivery(editDelivery);
    }

    formatPrice(value) {
        let result = value.replace(/[^0-9.]/g, '');
        let dotFound = false;
        result = [...result].map(c => {
            if(c === '.'){
                if(dotFound){
                    return '';
                }
                else {
                    dotFound = true;
                }
            }
            return c;
        }).join('');
        return result;
    }
    onChannelRemove(channel) {
        const { editDelivery } = this.state;
        if (!editDelivery.channels.includes(channel)) return;

        editDelivery['channels'] = editDelivery.channels.filter(c => c !== channel);

        this.setEditDelivery(editDelivery);
    }

    onChannelAdd(channel) {
        const { editDelivery } = this.state;
        if (!channel || !this.props.channels.includes(channel)) return;

        editDelivery['channels'] = [...editDelivery.channels, channel];

        this.setEditDelivery(editDelivery);
    }

    onReturnClick() {
        window.location.href = '/delivery';
    }

    onDuplicateClick() {
        const { duplicateDeliveryOption } = this.props;
        const { editDelivery } = this.state;
        this.setOpenDuplicateModal(false);
        duplicateDeliveryOption(editDelivery);
    }

    onCancelClick() {
        const { deliveryOption, editDelivery, changeMade } = this.props;
        if (JSON.stringify(deliveryOption) !== JSON.stringify(editDelivery)) {
            this.refreshDelivery();
            this.setFirstLoad(true);
        }
        if (changeMade !== false) this.setChangeMade(false);
    }

    onDeleteClick() {
        const { removeDeliveryOption } = this.props;
        const { editDelivery } = this.state;
        this.setOpenDeleteModal(false);
        removeDeliveryOption(editDelivery);
    }

    getPUTRequestFields(deliveryOption) {
        let result = {};
        if (deliveryOption.name) result.name = deliveryOption.name;
        if (deliveryOption.code) result.code = deliveryOption.code;
        if (deliveryOption.active) result.active = deliveryOption.active;
        if (deliveryOption.deliveryType) result.deliveryType = deliveryOption.deliveryType;
        if (deliveryOption.price) result.price = deliveryOption.price;
        if (deliveryOption.description) result.description = deliveryOption.description;
        if (deliveryOption.cutOffTime) result.cutOffTime = deliveryOption.cutOffTime;
        return result;
    }

    channelsNotInArray(subjects, data) {
        let result = [];
        subjects.forEach(v => {
            if (!data.includes(v)) result.push(v);
        });
        return result;
    }

    onSaveClick() {
        const { updateDeliveryOption } = this.props;
        const { editDelivery } = this.state;
        updateDeliveryOption(editDelivery);
        this.forceUpdate();
    }

    render() {
        const { deliveryOption, loading } = this.props;
        const { editDelivery, changeMade, openDuplicateModal, openDeleteModal } = this.state;

        if (true === loading || deliveryOption === undefined) {
            return <Loader />;
        } else {
            return (
                <div className="container-fluid deliverypage-container">
                    <div className="row">
                        <Header
                            openDuplicateModal={this.setOpenDuplicateModal.bind(this)}
                            onReturnClick={this.onReturnClick.bind(this)}
                            openDeleteModal={this.setOpenDeleteModal.bind(this)}
                            onCancelClick={this.onCancelClick.bind(this)}
                            onSaveClick={this.onSaveClick.bind(this)}
                            changeMade={changeMade}
                        />
                    </div>
                    <br />
                    <DeliveryOptionPage
                        onFieldChange={this.onFieldChange.bind(this)}
                        onChannelRemove={this.onChannelRemove.bind(this)}
                        onChannelAdd={this.onChannelAdd.bind(this)}
                        onReturnClick={this.onReturnClick.bind(this)}
                        editDelivery={editDelivery}
                    />
                    {/* modals */}
                    <ActionConfirmModal
                        onActionConfirmed={this.onDuplicateClick.bind(this)}
                        setModalOpen={this.setOpenDuplicateModal.bind(this)}
                        modalOpen={openDuplicateModal}
                        title={'Duplicate Delivery Option'}
                    />
                    <ActionConfirmModal
                        onActionConfirmed={this.onDeleteClick.bind(this)}
                        setModalOpen={this.setOpenDeleteModal.bind(this)}
                        modalOpen={openDeleteModal}
                        title={'Delete Delivery Option'}
                    />
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    const loadingSelector = createLoadingSelector(['(DeliveryOptions) GET']);
    return {
        deliveryOption: state.deliveryOptions.deliveryOption,
        currentUser: state.auth.currentUser,
        loading: loadingSelector(state),
        channels: state.utils.channels,
        stores: state.utils.stores,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getDeliveryOption: id => dispatch(deliveryOptionsActions.getDeliveryOption(id)),
        updateDeliveryOption: deliveryOption =>
            dispatch(deliveryOptionsActions.updateDeliveryOption(deliveryOption)),
        toggleActive: (deliveryOption, active) =>
            dispatch(deliveryOptionsActions.toggleActive(deliveryOption, active)),
        duplicateDeliveryOption: deliveryOption =>
            dispatch(deliveryOptionsActions.duplicateDeliveryOption(deliveryOption)),
        removeDeliveryOption: deliveryOption =>
            dispatch(deliveryOptionsActions.removeDeliveryOption(deliveryOption)),
        getChannels: () => dispatch(utilsActions.getChannels()),
        getStores: () => dispatch(utilsActions.getStores()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOption);
